import type { DsType } from "../../store/api/dataSourcesApi";

export const INTEGRATIONS_HUB = "/integrations";
export const JIRA_PATH = "/integrations/jira";
export const XERO_PATH = "/integrations/xero";

export type HubCategory = "all" | "data_source" | "tool";
export type InstanceTab = "overview" | "upload";

const DS_TYPES: DsType[] = [
  "search_index",
  "blob_storage",
  "unstructured_store",
  "byo",
];

export function isDsType(value: string | null): value is DsType {
  return Boolean(value && DS_TYPES.includes(value as DsType));
}

export function dataSourceInstancePath(
  id: string,
  tab?: InstanceTab,
): string {
  const base = `${INTEGRATIONS_HUB}/data-sources/${encodeURIComponent(id)}`;
  if (tab && tab !== "overview") return `${base}?tab=${encodeURIComponent(tab)}`;
  return base;
}

export function createDataSourceHubPath(opts?: {
  returnTo?: string;
  tab?: string;
  type?: DsType;
}): string {
  const params = new URLSearchParams();
  params.set("create", "1");
  if (opts?.returnTo) params.set("returnTo", opts.returnTo);
  if (opts?.tab) params.set("tab", opts.tab);
  if (opts?.type) params.set("type", opts.type);
  return `${INTEGRATIONS_HUB}?${params.toString()}`;
}
